import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../services/api';
import './FAQ.css';

const FAQ = () => {
	const [faqs, setFaqs] = useState([]);
	const [selectedCategory, setSelectedCategory] = useState('all');
	const [expandedId, setExpandedId] = useState(null);
	const [loading, setLoading] = useState(true);

	const categories = [
		{ value: 'all', label: '전체' },
		{ value: 'order', label: '주문/결제' },
		{ value: 'delivery', label: '배송' },
		{ value: 'return', label: '교환/반품' },
		{ value: 'product', label: '상품' },
		{ value: 'member', label: '회원' },
		{ value: 'etc', label: '기타' },
	];

	useEffect(() => {
		fetchFAQs();
	}, [selectedCategory]);

	const fetchFAQs = async () => {
		try {
			setLoading(true);
			const url = selectedCategory === 'all' 
				? `${API_BASE_URL}/products/faqs/`
				: `${API_BASE_URL}/products/faqs/?category=${selectedCategory}`;
			
			const response = await fetch(url);
			
			if (!response.ok) {
				throw new Error(`HTTP ${response.status}`);
			}
			
			const data = await response.json();
			
			let faqList = [];
			if (Array.isArray(data)) {
				faqList = data;
			} else if (data && Array.isArray(data.results)) {
				faqList = data.results;
			}
			
			setFaqs(faqList);
		} catch (error) {
			console.error('FAQ 로딩 실패:', error);
			setFaqs([]);
		} finally {
			setLoading(false);
		}
	};

	const toggleFAQ = (id) => {
		setExpandedId(expandedId === id ? null : id);
	};

	if (loading) {
		return (
			<div className="faq-container">
				<div className="faq-loading">FAQ를 불러오는 중...</div>
			</div>
		);
	}

	return (
		<div className="faq-container">
			<h1>❓ 자주 묻는 질문</h1>

			<div className="faq-categories">
				{categories.map(cat => (
					<button
						key={cat.value}
						className={`category-btn ${selectedCategory === cat.value ? 'active' : ''}`}
						onClick={() => setSelectedCategory(cat.value)}
					>
						{cat.label}
					</button>
				))}
			</div>

			{faqs.length === 0 ? (
				<div className="faq-empty">
					<p>등록된 FAQ가 없습니다.</p>
				</div>
			) : (
				<div className="faq-list">
					{faqs.map((faq, index) => (
						<div key={faq.id} className="faq-item">
							<div 
								className="faq-question"
								onClick={() => toggleFAQ(faq.id)}
							>
								<span className="faq-num">{index + 1}</span>
								<span className="faq-category-badge">{faq.category_display}</span>
								<span className="faq-title">{faq.question}</span>
								<span className="faq-toggle">{expandedId === faq.id ? '▲' : '▼'}</span>
							</div>
							
							{expandedId === faq.id && (
								<div className="faq-answer">
									<p>{faq.answer}</p>
								</div>
							)}
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default FAQ;